var _style, _linearGradient, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHerdao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 765.5,
    height: 282,
    viewBox: "0 0 765.5 282",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000093868503004234200670000005692299572083819693_);}\n\t.st2{fill:url(#SVGID_00000065760571173213080540000012715936591223213720_);}\n\t.st3{fill:url(#SVGID_00000034802195669428910470000005700579094890592936_);}\n\t.st4{fill:url(#SVGID_00000008856292059715960380000017960402694104621957_);}\n\t.st5{fill:url(#SVGID_00000155835607401541270370000009305069391297697672_);}\n")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106109268514847664740000003631681591777414322_",
    x1: 374.26,
    x2: 648.61,
    y1: 525.85,
    y2: 525.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7495",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BD98",
    offset: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130.6 -384.86)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 123.77,
    x2: 372.12,
    y1: 641.84,
    y2: 641.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F173",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FF83",
    offset: 0.3697
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 188.5,
    y: 617,
    width: 39.8,
    height: 49.6,
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114039389535712246150000014468364458463249598_",
    x1: 123.77,
    x2: 372.12,
    y1: 527.97,
    y2: 527.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F173",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81FF83",
    offset: 0.3697
  })), /*#__PURE__*/React.createElement("path", {
    d: "m329.4 420.4c-32.6-28.7-70.4-31.1-113-31.1h-85.8v277.3h27.7v-119.8h30.2v46.8h39.8v-46.8h30.2v118.1c4.2-0.5 8.2-1.1 12.1-1.8l-1.5-1.5c-2.6-3.4-3.8-7.7-3.8-11.9-0.9-8.5 5.5-16 14-16.8h1.5c4.3-0.2 8.5 1.5 11.3 4.9 3.7 5.6 4.4 12.5 2.3 18.7 16.3-6.2 30.1-15.4 42.4-28.1 25.3-26.6 38.7-61.5 38.7-101.1 0-43.5-15.9-80.3-46.1-106.9z",
    fill: "url(#SVGID_00000114039389535712246150000014468364458463249598_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648.6 666.6-137.1-281.5-137.2 281.5h75.7v-119h91.5v23h-61.7v24.1h48.5v22.3h-48.5v26.4h61.7v23.2zm-83.9-33.8h1.5c4.3-0.2 8.5 1.5 11.3 4.9 4.7 7 4.7 16.2 0 23.4-2.8 3.6-7 5.7-11.7 5.5-4.5 0.2-8.5-1.7-11.3-5.1-2.6-3.4-3.8-7.7-3.8-11.9-0.8-8.5 5.5-16 14-16.8z",
    fill: "url(#SVGID_00000106109268514847664740000003631681591777414322_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008838284993533553640000003957883168110256530_",
    x1: 639.49,
    x2: 894.44,
    y1: 643.12,
    y2: 643.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CD0FA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83F2D4",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m765.2 619.6h-21.7l-0.6 44.2c9.3 1.9 19.3 2.8 30 2.8 4 0 7.9-0.2 11.7-0.5z",
    fill: "url(#SVGID_00000008838284993533553640000003957883168110256530_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057852064382059749860000002151836182651213487_",
    x1: 639.49,
    x2: 894.44,
    y1: 583.95,
    y2: 583.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CD0FA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83F2D4",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m777.6 596.8c4.7-3 7.7-8.1 7.4-13.6-0.2-5.1-3-9.6-7.2-12.1-6.2-2.3-12.8-3-19.4-2.3h-15.7v30.4h16.6c6.2 0.6 12.5 0 18.3-2.4z",
    fill: "url(#SVGID_00000057852064382059749860000002151836182651213487_)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141427876467659573650000009010658910138280107_",
    x1: 639.49,
    x2: 894.44,
    y1: 524.83,
    y2: 524.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CD0FA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83F2D4",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m864.8 430.4c-22.1-28.1-51.3-41.1-91.9-41.1-39.8 0-72.4 14.5-94.1 42.4-19.4 24.3-30 58.3-30 96 0 36.6 10.9 70.9 30.4 96.8 9.5 12.4 20.7 22 33.8 28.9v-105.7h53.8c11.3-1.1 22.6 1.1 32.8 6 10.2 6.4 16.4 17.7 16.4 29.8-0.2 14-9.2 26.4-22.3 30.6l21 46.3c3.5-1.1 6.9-2.5 10.2-3.9-0.8-2.2-1.2-4.5-1.2-6.8-0.9-8.5 5.5-16 14-16.8h1.5c4.3-0.2 8.5 1.5 11.3 4.9 0.4 0.6 0.8 1.3 1.1 2 6.2-5.4 11.9-11.5 17-18.4 20.2-27.9 27.5-66.6 27.5-93.6 0-35.7-11.9-72.9-31.3-97.4z",
    fill: "url(#SVGID_00000141427876467659573650000009010658910138280107_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerdao);
export default __webpack_public_path__ + "static/media/herdao.e92ca0b175884705a12073711791d0cc.svg";
export { ForwardRef as ReactComponent };